/** Static demo profile photos in public/demo-profiles (deployed with Cloudflare Pages). */

const DEMO_PROFILE_IDS = new Set([
  "carla",
  "marco",
  "lina",
  "tomas",
  "yuki",
  "sofia",
  "jamal",
  "elena",
  "ravi",
  "naomi",
  "helena",
  "andre",
  "vera",
  "felix",
  "marta",
  "diego",
  "nina",
]);

export function demoProfileThumbnailUrl(personaId) {
  if (!personaId || !DEMO_PROFILE_IDS.has(personaId)) return null;
  return `/demo-profiles/${personaId}.jpg`;
}

export function demoProfileThumbnailUrlForName(name) {
  const id = String(name || "").trim().toLowerCase();
  return demoProfileThumbnailUrl(id);
}
